import { selectEditorSettingsData } from "../draft-selectors";
import { deleteManyColumnOptionStates, deleteManyColumnTemplates, updateOrAddDatapointRequests, updateOrAddManyColumnOptionStates, updateOrAddManyColumnTemplates } from "../helpers";
export const unsetColumnInVariationReducer = (state, action) => {
    const data = selectEditorSettingsData(state);
    if (!data) {
        return;
    }
    const optionState = data.columns?.options?.find((option) => option.id === action.payload.id);
    if (!optionState) {
        return;
    }
    optionState.isGroup = false;
    optionState.variation = false;
    const optionsToDelete = data.columns?.options?.filter((option) => option.groupId === action.payload.id).map((o) => o.id) ?? [];
    deleteManyColumnTemplates(state, optionsToDelete);
    deleteManyColumnOptionStates(state, optionsToDelete);
    updateOrAddDatapointRequests(state, [optionState]);
    updateOrAddManyColumnTemplates(state, [optionState]);
    updateOrAddManyColumnOptionStates(state, [optionState]);
};
